import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { School } from '../../entities/school';
import { Reservation } from '../../entities/reservation';
import { EventReservation } from '../../entities/event-reservation';
import { Student } from '../../entities/student';
import { CardType } from '../../entities/card-type';


@Injectable()
export class BackOfficeService {
    private resourceUrl = 'api/backoffice';

    constructor(private http: HttpClient) {}

    createCheckoutSession(school: School, reservationId: number): Observable<string> {
        if (school && school.id) {
            return this.http
                       .post(`${this.resourceUrl}/schools/${school.id}/reservations/${reservationId}/checkout`,
                        {},
                        {responseType: 'text'})
                        .map((res: any) => res);
        }

        return Observable.of('error');

    }

    createReservationWithCheckOutSession(reservation: Reservation): Observable<string> {
        let copy: Reservation = Object.assign({}, reservation);
        let url = this.resourceUrl + '/schools/' + reservation.school.id
                                   + '/lessons/' + reservation.lesson.id
                                   + '/students/' + reservation.student.id
                                   + '/checkout';
        if (copy) {
            return this.http
                        .post(url, {}, {responseType: 'text'})
                        .map((res: any) => res );
        }

        return Observable.of('error');
    }

    createEventReservationWithCheckOutSession(eventReservation: EventReservation): Observable<string> {
        let copy: Reservation = Object.assign({}, eventReservation);
        let url = this.resourceUrl + '/schools/' + eventReservation.school.id
                                   + '/events/' + eventReservation.event.id
                                   + '/students/' + eventReservation.student.id
                                   + '/checkout';
        if (copy) {
            return this.http
                        .post(url, {}, {responseType: 'text'})
                        .map((res: any) => res );
        }

        return Observable.of('error');
    }

    createCardWithCheckOutSession(schoolID: number, studentId: number, cardTypeId: number): Observable<string> {
        let url = this.resourceUrl + '/schools/' + schoolID
                                   + '/card-types/' + cardTypeId
                                   + '/students/' + studentId
                                   + '/checkout';
        return this.http
                    .post(url, {}, {responseType: 'text'})
                    .map((res: any) => res );
    }

    createOrResumeCreateBackofficeAccount(school: School) {
        if (school && school.id) {
            if (school.backofficeAccountId) {
                return this.http
                        .post(`${this.resourceUrl}/accounts/${school.id}/resume`, {}, {responseType: 'text'})
                        .map((res: any) => res);
            }

            return this.http
                        .post(`${this.resourceUrl}/accounts/${school.id}`, {}, {responseType: 'text'})
                        .map((res: any) => res);
        }
    }

    getCheckoutSessionStatus(checkoutSessionId: string): Observable<string> {
        return this.http
                    .get(`${this.resourceUrl}/checkout/${checkoutSessionId}`, {responseType: 'text'})
                    .map((res: any) => res );
    }

    isOnlinePaymentsEnabled(school: School): boolean {
        return school && school.onlinePaymentsModuleEnabled && school.acceptOnlinePayments;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/backoffice/backoffice.service.ts